<template>
  <div>
    <div class="sale-monter-header">
      <div class="brand">
        <nav class="navbar navbar-default">
          <button type="button" class="navbar-toggle" @click.stop="$refs.sidebarMenu.handleTogglePageSmallMenu()">
             <i :class="['fa', isSidebarOpen ? 'fa-times' : 'fa-bars']" aria-hidden="true"></i>
          </button>
          <a class="navbar-brand sale-monter-logo" href="/">
            <img class="img-responsive" src="/static/dists/img/logo.png">
          </a>
          <a class="navbar-brand sale-monter-logo-mobi" href="/">
            <img class="img-responsive" src="/static/dists/img/logomobi.png" alt="">
          </a>
        </nav>
        <div class="member-plan text-size-16" :class="memberPlanClass">
          {{memberPlan}}
        </div>
        <premium-trial v-if="isPremiumTrial" />
      </div>
      <div class="categories">
        <div class="box-notifications">
          <div class="notifications">
            <i class="fa fa-bell"></i> <span class="title-notifications"> お知らせ</span>
            <span v-if="countNoticeUnread" class="count-notice-unread">{{ countNoticeUnread }}</span>
          </div>
          <div v-show="showHeaderListNotification" class="header-list-notifications">
            <div class="box-btn-close">
              <a class="btn-close" href="javascript:void(0)">閉じる <i class="fa fa-times"></i></a>
            </div>
            <div v-for="(notice, noticeIndex) in notices" :key="`notice-key-${noticeIndex}`" class="notification">
              <div class="notification-release-date">{{ notice.date }}</div>
              <a
                :class="{'notification-content': true, 'unread': !notice.is_notice_read }"
                href="javascript:void(0)"
                v-html="replaceHTMLSellerInfo(notice.title)"
                @click="handleViewNotice(notice)">
              </a>
            </div>
            <div class="box-btn-view-all text-center" @click="handleViewAllNotice()">
              <a class="btn-view-all" href="javascript:void(0)">すべてのお知らせを表示する</a>
            </div>
          </div>
        </div>
        <div class="seller-info text-white">
          <div>会員ID : <span>{{userInfo.sellerId}}</span></div>
          <div>
            <span :class="{ 'm-r-sm': userInfo.companyName && userInfo.companyName.length > 0 }">
            {{userInfo.companyName || ''}}
            </span>
            <span>
            {{sellerName}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- End refactor header -->
    <!--Navigation-->
    <sidebar-menu ref="sidebarMenu" @setSidebarMenuPageSmallMode="setSidebarMenuPageSmallMode" />
    <!-- Page Content -->
    <div id="wrapper">
      <reload-notification v-if="isChanged" data-backdrop="static" data-keyboard="false" @reload="reload"></reload-notification>
      <div v-if="hasReturnRecommend" class="fba-longterm-stock font-bold">
        <span>
          <i class='fa fa-exclamation-triangle' aria-hidden='true'></i>
          FBAで無駄な手数料が <span class="text-primary text-size-28">{{ formatNumber(totalFbaFee) }}</span> 円発生しています！
        </span>

        <button class="btn-warning" @click="$router.push('/salemon-agent')">
          手数料を削減する
          <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
        </button>
      </div>
      <div class="help-bubble-wrapper">
        <span v-show="helpData.length" class="toggle-btn" @click.stop="toggleHelpBubble()">
          <i class="fa fa-question-circle" aria-hidden="true"></i> ヘルプ
        </span>
        <div v-show="isShowBubble" ref="helpBubble" class="help-bubble" @click.stop>
          <ul>
            <li v-for="(item, index) in helpData" :key="index">
              <a :href="item.url" target="_blank" @click="handleClickHelpLink(item)">{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>
      <popup v-if="isShowPopup" :popupData="popupData" @close="handleClosePopup" />
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import ReloadNotification from '@/components/ReloadNotification'
import Popup from '@/components/Popup'
import PremiumTrial from '@/components/PremiumTrial'
import SidebarMenu from '@/components/SidebarMenu'
import SettingService from '@/services/settingservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import Util, { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  components: {
    ReloadNotification,
    Popup,
    PremiumTrial,
    SidebarMenu
  },
  data () {
    return {
      isChanged: false,
      version: '',
      showHeaderListNotification: false,
      isShowBubble: false,
      helpData: [],
      isShowPopup: false,
      popupData: {
        content: '',
        noDispSuppression: false,
        noDispTerm: 0
      },
      isSidebarOpen: false
    }
  },
  created () {
    this.fetchServer()
    this.getHelpData(this.$route.path)
    this.getPopupData(this.$route.path)
    this.$store.dispatch('fetchNotices')
    this.$store.dispatch('fetchAnalysisMenu')
    this.$store.dispatch('fetchWareHouseIcons')
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      notices: 'getNotices',
      countNoticeUnread: 'countNoticeUnread'
    }),
    sellerName () {
      const {sellerName} = this.userInfo
      return sellerName ? `${sellerName}様` : ''
    },
    storageSkipShowRegisterInfoName () {
      return `${this.userInfo.sellerId}-SkipShowRegisterInfo`
    },
    storageSideMenuCloseName () {
      return `${this.userInfo.sellerId}-SideMenuClose`
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    },
    memberPlan () {
      if (!this.isBasicPlan) {
        return 'プレミアム'
      }
      return 'ベーシック'
    },
    memberPlanClass () {
      if (!this.isBasicPlan) {
        return 'plan-premium-text plan-premium-bg'
      }
      return 'plan-basic-text plan-basic-bg'
    },
    isPremiumTrial () {
      return this.userInfo.isPremiumTrial
    },
    hasReturnRecommend () {
      return this.userInfo.hasReturnRecommend
    },
    totalFbaFee () {
      return this.userInfo.totalFbaFee
    }
  },
  watch: {
    $route (to, from) {
      this.setWrapperBg(to.name)
      if (to.name !== 'Notices' || (to.query && !to.query.scroll_to)) {
        this.fetchServer()
      }
      this.getHelpData(to.path)
      this.getPopupData(to.path)
    }
  },
  methods: {
    replaceHTMLSellerInfo,
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    async fetchServer () {
      try {
        let params = {}
        let routeName = this.$route.name
        if (routeName === 'Home') {
          params = { screen_name: 'Home' }
        }
        const response = await SettingService.getSellerInformation(params)
        const nextVersion = response.seller.version
        const currentVersion = this.$store.getters.getUser.version
        if (currentVersion !== nextVersion) {
          this.version = nextVersion
          this.isChanged = true
        }
        this.$store.commit('setUser', response.seller)
        this.$store.dispatch('getStorageSettingPaginationRows')
      } catch (err) {
        this.err = err
      }
    },
    reload () {
      $('#reloadNotification').modal('hide')
      store.commit('setVersion', this.version)
      location.reload(true)
    },
    handleViewNotice (notice) {
      this.showHeaderListNotification = false
      this.$router.push(`/Notices?scroll_to=${notice.id}`)
      this.handleScrollToNotice()
    },
    handleViewAllNotice () {
      this.showHeaderListNotification = false
      this.$router.push('/Notices?scroll_to=top')
      this.handleScrollToNotice()
    },
    handleToggleHeaderNotification () {
      let toggleHeaderNotiClasses = ['notifications', 'fa fa-bell', 'title-notifications', 'count-notice-unread']
      let notToggleHeaderNotiClasses = ['box-btn-close', 'header-list-notifications', 'notification-release-date', 'notification-content', 'notification-content unread', 'notification']
      window.addEventListener('click', (e) => {
        let eventClass = $(e.target).attr('class')
        if (eventClass !== null && eventClass !== undefined) {
          if (toggleHeaderNotiClasses.includes(eventClass)) {
            this.showHeaderListNotification = !this.showHeaderListNotification
          } else if (eventClass === 'btn-close') {
            this.showHeaderListNotification = false
          } else if (!notToggleHeaderNotiClasses.includes(eventClass)) {
            this.showHeaderListNotification = false
          }
        } else {
          this.showHeaderListNotification = false
        }
      })
    },
    handleScrollToNotice () {
      let route = this.$route
      let routeName = route.name
      if (routeName === 'Notices') {
        let noticeId = route.query.scroll_to || null
        if (!noticeId || noticeId === 'top') {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        } else if (noticeId) {
          setTimeout(() => {
            let elementId = `panel-notice-${noticeId}`
            const element = document.getElementById(elementId)
            if (element) {
              let collapseNoticeSelector = $(`#collapse-notice-${noticeId}`)
              collapseNoticeSelector.attr('aria-expanded', true)
              collapseNoticeSelector.addClass('in')
              $(`#panel-notice-${noticeId} .accordion-title`).attr('aria-expanded', true)

              window.scroll({
                top: (element.getBoundingClientRect().top + window.scrollY) - 70,
                behavior: 'smooth'
              })
            }
          }, 600)
        }
      }
    },
    async getHelpData (path) {
      this.helpData.length = 0
      this.isShowBubble = false
      let params = {
        path: path
      }
      await SettingService.getHelpData(params)
        .then((response) => {
          this.helpData = response.data
        })
    },
    toggleHelpBubble () {
      this.isShowBubble = !this.isShowBubble
      if (this.isShowBubble) {
        let logParams = {
          name: eventCode.help.list,
          properties: {
            path: this.$route.path
          }
        }

        EventService.postTrackLog(logParams)
      }
    },
    handleClickHelpLink (item) {
      if (this.isShowBubble) {
        let logParams = {
          name: eventCode.help.show,
          properties: {
            path: this.$route.path,
            title: item.title
          }
        }

        EventService.postTrackLog(logParams)
      }
    },
    handleClickOutsideHelpBubble () {
      const bubble = this.$refs.helpBubble
      if (bubble && !bubble.contains(event.target)) {
        this.isShowBubble = false
      }
    },
    async getPopupData (path) {
      this.closePopup()
      let params = {
        path: path
      }
      await SettingService.getPopupData(params)
        .then((response) => {
          if (response.data) {
            this.popupData = response.data
            this.isShowPopup = true
          }
        })
    },
    handleClosePopup (noDispOption = false) {
      this.closePopup()
      let params = {
        seq: this.popupData.seq,
        noDispOption: noDispOption
      }
      SettingService.updatePopupDispControl(params)
    },
    closePopup () {
      this.isShowPopup = false
      $('#popup').modal('hide')
    },
    setWrapperBg (name) {
      if (name === 'ProductsNew') {
        $('#wrapper').css('background', '#f9f9f9')
      } else if (name === 'Home') {
        $('#wrapper').css('background', '#EFF5FB')
      } else {
        $('#wrapper').css('background', '#f1f3f6')
      }
    },
    setSidebarMenuPageSmallMode (isSidebarOpen) {
      this.isSidebarOpen = isSidebarOpen
    }
  },
  mounted () {
    this.setWrapperBg(this.$route.name)
    this.handleToggleHeaderNotification()
    document.addEventListener('click', this.handleClickOutsideHelpBubble)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutsideHelpBubble)
  }
}
</script>
<style scoped>
  .content {
    padding-top: unset;
  }
  .help-bubble-wrapper {
    background-color: inherit;
    position: relative;
    display: flex;
    justify-content: right;
    align-items: end;
    color: #3498db;
    padding-right: 20px;
    height: 40px;
    font-size: 20px;
  }

  .help-bubble-wrapper .toggle-btn {
    cursor: pointer;
    display: inline-flex;
    gap: 5px;
    align-items: center;
  }

  .help-bubble {
    position: absolute;
    top: calc(100% + 5px);
    right: 10px;
    background-color: #E8F5FB;
    padding: 10px 20px;
    border: 1px solid #afd7fd;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    min-width: 280px;
    width: max-content;
    max-width: 800px;
    word-wrap: break-word;
    min-height: 200px;
    font-size: 16px;
    z-index: 102;
  }

  .help-bubble ul {
    padding-left: 20px;
    margin: unset;
  }

  .help-bubble ul li {
    margin-bottom: 10px;
  }

  .help-bubble::before {
    content: '';
    position: absolute;
    top: -21px;
    right: 12px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent #afd7fd transparent;
  }

  .help-bubble::after {
    content: '';
    position: absolute;
    top: -20px;
    right: 12px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent #dcf2fd transparent;
  }

  .fa-question-circle {
    font-size: 30px;
  }

  .fba-longterm-stock {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    flex-wrap: nowrap;
    background: linear-gradient(90deg, #ffb347 0%, #ff5858 100%);
    color: #fff;
    font-size: 20px;
    padding: 5px;
    .fa-exclamation-triangle {
      font-size: 30px;
      padding: 5px;
    }
    .btn-warning {
      font-size: 18px;
      text-align: center;
      height: fit-content;
      border-radius: 4px;
      border: 1px solid #595959;
      padding: 3px 12px;
      color: #666;
    }
  }

  .navbar-default {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: left;
    padding: 5px 10px;
    gap: 10px;
  }

  .navbar-default::before, .navbar-default::after {
    content: unset;
  }

  .navbar-toggle {
    font-size: 32px;
    float: unset;
    padding: 0;
    margin: 0;
  }

  .sale-monter-logo-mobi {
    width: 24px;
    padding: 0 !important;
    align-content: center;
  }

  @media (max-width: 425px) {
    .navbar-toggle {
      font-size: 24px;
    }
    .sale-monter-logo-mobi {
      width: 20px;
    }
    .text-size-16 {
      font-size: 12px;
    }
    .member-plan {
      width: 60px;
    }
    .sale-monter-header .seller-info  {
      padding: 0;
      padding-right: 5px;
    }
    .sale-monter-header .brand {
      gap: 5px;
    }
    .help-bubble-wrapper {
      font-size: 14px;
      padding-right: 10px;
    }
    .fa-question-circle {
      font-size: 20px;
    }
    .help-bubble {
      max-width: 300px;
      font-size: 14px;
    }
    .fba-longterm-stock {
      font-size: 14px;
      .fa-exclamation-triangle {
        font-size: 16px;
        padding: 5px;
      }
      .btn-warning {
        font-size: 14px;
      }
    }
  }

  @media (max-width: 320px) {
    .navbar-default {
      padding: 5px;
    }
    .navbar-toggle {
      font-size: 20px;
    }
    .sale-monter-logo-mobi {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainFrame.vue